import { createSlice } from '@reduxjs/toolkit';

const schedulingSlice = createSlice({
  name: "scheduling",
  initialState: {
    manageCalendarsDialogOpen: false,
    scheduleMeetingDialogData: null,
  },
  reducers: {
    setManageCalendarsDialogOpen: (state, action) => {
      state.manageCalendarsDialogOpen = action.payload;
    },
    setScheduleMeetingDialogData: (state, action) => {
      state.scheduleMeetingDialogData = action.payload;
    },
  },
});

export const selectManageCalendarsDialogOpen = ({ scheduling }) => scheduling.manageCalendarsDialogOpen;
export const selectScheduleMeetingDialogData = ({ scheduling }) => scheduling.scheduleMeetingDialogData;

export const { setManageCalendarsDialogOpen, setScheduleMeetingDialogData } = schedulingSlice.actions;

export default schedulingSlice.reducer;